import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import Topics from './components/Topics';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import FAQ from './components/FAQ';
import Carousel from './components/Carousel';
import App from './components/App';
import Media from './components/Media';
import Features from './components/Features';
import About from './components/About';
import Contact from './components/Contact';
import Index from './components/Index';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Comments />
        <Topics />
        <Updates />
        <Ranking />
        <Cards />
        <FAQ />
        <Carousel />
        <App />
        <Media />
        <Features />
        <About />
        <Contact />
        <Index />
      </main>
      <Footer />
    </div>
  );
}